export default __webpack_public_path__ + "static/media/demo-1.f6d3bb87.png";